<template>
  <div class="device-chart">
        <ApexCharts ref="deviceChart" type="donut" :options="chartOptions" class="mb-6" :series="series"></ApexCharts>
        <div class="devices-numbers">
        <div v-if="chartData.length > 0 && (this.displayColumn != 'null' || !this.displayColumn) && !isEmptyChart">
          <span class="m-6 chart-device-span" :key="index" v-for="(value, index) in chartData">
            <vs-icon :icon="chartIcons[value.device_type]" v-bind:style="{color:chartColors[value.device_type]}"  icon-pack="speakol" class="mr-2"></vs-icon>
            <span style="position: relative; bottom: 4px;"><span style="color: #2c2c2c; opacity: 56%;">{{formatName(value.device_type)}}</span> <span class="chart-percentage ml-2">{{value.percentage === 'NaN' ? 0 : value.percentage}}%</span></span>
          </span>
        </div>
        <div v-else>
        <span class="m-6 chart-device-span" :key="index"   v-for="(value, index) in initData">
          <vs-icon :icon="chartIcons[value.device_type]" v-bind:style="{color:chartColors[value.device_type]}"  icon-pack="speakol" class="mr-2"></vs-icon>
          <span style="position: relative; bottom: 4px;"><span style="color: #2c2c2c; opacity: 56%;">{{formatName(value.device_type)}}</span> <span class="chart-percentage ml-2">{{value.percentage}}%</span></span>
        </span>
        </div>
        </div>
  </div>
</template>
<script>
export default {
  props: {
    chartData: {
      type: Array,
      required: true
    },
    displayColumn:{
      type: String,
      required: false
    },
    accountHasCampaigns: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    chartData () {
      this.renderChart()
    },
    displayColumn () {
      this.renderChart()
    }
  },
  mounted () {
    this.renderChart()
  },
  methods: {
    formatName (name) {
      return name === 'ios' ? 'iOS' : name.charAt(0).toUpperCase() + name.slice(1)
    },
    async emptyChart () {
      let errorMessage = this.$t('You do not have any campaigns.')
      let errorIcon = 'speakol-no-horn'
      if (this.accountHasCampaigns) {
        errorMessage = this.$t('There is no data showing for<br> the date you have specified.')
        errorIcon = 'speakol-calendar'
      }
      this.isEmptyChart = true
      this.chartOptions = {
        labels: ['no-data'],
        colors : ['#F1F1F1'],
        series : [1],
        tooltip: {
          custom () {
            return `
              <div style="background-color:white;padding:20px 20px 20px 55px;color:#2C2C2C;position:relative;">
                <span style="font-size:25px;background-color:white;margin:8px;position:absolute;top:${errorIcon === 'speakol-no-horn' ? '10px' : '20px'};left:10px;" class="speakol icon-size ${errorIcon}"></span>
                ${errorMessage}
              </div>
              `
          }}
      }

    },
    renderChart () {
      this.isEmptyChart = false
      const labels = []
      const colors = []
      const series = []
      let total = 0

      if (this.chartData.length === 0 || !this.displayColumn  || this.displayColumn === 'null') {
        this.emptyChart()
        return
      }
      total = this.chartData.reduce((total, obj) => obj[this.displayColumn] + total, 0)
      for (let i = 0; i < this.chartData.length; i++) {
        this.chartData[i].percentage = ((this.chartData[i][this.displayColumn] / total) * 100).toFixed(2)
        colors.push(this.chartColors[this.chartData[i].device_type])
        if (this.chartData[i].percentage === 'NaN') {
          this.emptyChart()
          return
        }
        labels.push(this.chartData[i].device_type)
        series.push(this.chartData[i][this.displayColumn])
      }
      this.chartOptions = {
        labels,
        colors,
        series
      }
    }
  },
  data () {
    const chartData = this.chartData
    return {
      isEmptyChart: false,
      initData : [
        {
          'device_type' : 'desktop',
          'impressions' : 0,
          'clicks' : 0,
          'spent' : 0,
          'percentage' : 0
        },
        {
          'device_type' : 'ios',
          'impressions' : 0,
          'clicks' : 0,
          'spent' : 0,
          'percentage' : 0
        },
        {
          'device_type' : 'android',
          'impressions' : 0,
          'clicks' : 0,
          'spent' : 0,
          'percentage' : 0
        }
      ],
      chartColors : {
        'desktop' : '#0092D7',
        'ios' : '#6ec8ba',
        'android' : '#00336e'
      },
      chartIcons : {
        'desktop' : 'speakol-desktop',
        'ios' : 'speakol-mobile-2',
        'android' : 'speakol-mobile-3'
      },
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
          width:100
        },
        legend: {
          show: false,
          position: 'bottom'
        },
        dataLabels: {
          enabled: false
        },
        labels: [],
        colors:[],
        states: {
          hover: {
            filter: {
              type: 'none'
            }
          }
        },
        tooltip: {
          custom ({seriesIndex, w}) {
            const chartColors = {
              'desktop' : '#0092D7',
              'ios' : '#6ec8ba',
              'android' : '#00336e'
            }
            const chartIcons = {
              'desktop' : 'speakol-desktop',
              'ios' : 'speakol-mobile-2',
              'android' : 'speakol-mobile-3'
            }
            for (let i = 0; i < chartData.length; i++) {
              if (chartData[i].device_type === w.globals.labels[seriesIndex]) {
                return `
                  <div style="padding: 16px 20px 20px 16px;">
                  <span style="position:relative;top:6px;font-size:25px;color:${chartColors[chartData[i].device_type]}" class="speakol icon-size ${chartIcons[chartData[i].device_type]} ${chartData[i].device_type === 'desktop' ? 'test-icon' : ''}"></span>
                  <span class="popup-titles" style="margin-right:8px;font-size:14px;">${chartData[i].device_type === 'ios' ? 'iOS' : chartData[i].device_type.charAt(0).toUpperCase() + chartData[i].device_type.slice(1)}</span>
                  <span class="popup-percentage" style="">${chartData[i].percentage}%</span>
                  <br>
                  <br>
                  <div style="">
                  <span class="popup-titles">Spent</span><br>
                  <span class="popup-numbers">$${chartData[i].spent.toLocaleString()}</span> <br>
                  <span style="" class="" style="margin-top:16px;margin-bottom:16px;"> <br>
                  <span class="popup-titles"> Clicks</span><br>
                  <span class="popup-numbers">${chartData[i].clicks.toLocaleString()}</span> <br>
                  </span> <br>
                  <span class="popup-titles">Impressions</span><br>
                  <span class="popup-numbers">${chartData[i].impressions.toLocaleString()}</span>
                  </div>
                  </div>`
              }
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.device-chart::v-deep {
  .test-icon {
    margin-right: 10px;
  }

  .icon-size {
    width: 20.5px;
    height: 20.5px;
  }

  .apexcharts-tooltip {
    box-shadow: 0 4px 50px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
  }

  .devices-numbers {
    text-align: center;
  }

  .popup-titles {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.1px;
    color: rgba(44, 44, 44, 0.56);
  }

  .popup-numbers {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  .popup-percentage {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  .chart-percentage {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  @media (max-width: 768px) {
    .chart-device-span {
      display: block;
      position: relative;
      right: 20px;
      text-align: left;
    }
  }

  @media (max-width: 1440px) {
    .chart-device-span {
      margin: 6px;
    }
  }
}
</style>
